import { render, staticRenderFns } from "./examInitiateForm.vue?vue&type=template&id=6282faa4&scoped=true&"
import script from "./examInitiateForm.vue?vue&type=script&lang=js&"
export * from "./examInitiateForm.vue?vue&type=script&lang=js&"
import style0 from "./examInitiateForm.vue?vue&type=style&index=0&id=6282faa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282faa4",
  null
  
)

export default component.exports